export const bomContainsNullFootprint = bomItems =>
	bomItems.filter(item => item.footprint === null || item.footprint === 0).length > 0;

export const bomContainsNullPrice = bomItems =>
	bomItems.filter(item => item.price === null || item.price === 0).length > 0;
